import { ModalBase } from './base/base';
import { PageBase } from './base/pageBase'
import { ConfirmDialog, DialogResultType } from './dialog'


/**
 * 業務共通処理ユーティリティ
 */
//export default class Business {
export class Business {

    static readonly conifrmTitie = 'このページから移動しますか？';
    static readonly conifrmMessage = '行った変更が保存されない可能性があります。';
    //static readonly conifrmMessage = 'このページから移動しますか？\n行った変更が保存されない可能性があります。';

    /**
     * 表示ページの状態を取得・設定
     */
    static readonly page = {
        /**
         * 編集中チェック
         * @param event
         */
        get pageInstance(): PageBase {
            //const spirit = $('#body-container').data('SPIRIT') || $(document).data('SPIRIT');
            const spirit = $(PageBase.INSTANCE_RETAINER).data(PageBase.DATA_KEY) || $(document).data(PageBase.DATA_KEY);
            //debugger;
            //console.log(spirit instanceof PageBase);
            //console.log(spirit._proto_ instanceof PageBase);

            ////参照先がかわった？効かなくなった（謎？？？）
            ////少し気持ち悪い。

            //if (spirit instanceof PageBase) {
            //    return spirit;
            //}
            //return null;

            ////おそらくWebPackModule化していることにより、
            ////ページで作ったPageBaseと当global領域で作成したpageBaseは別物になっている様な気がする(レキシカルスコープなので)

            return spirit;
        },

        /**
         * 編集中チェック(Modal)
         */
        get modalInstance(): ModalBase {
            const spirit = $(ModalBase.INSTANCE_RETAINER).data(ModalBase.DATA_KEY) || $(document).data(ModalBase.DATA_KEY);
            return spirit;
        },

        /**
         * 編集中チェック（All）
         * @param event
         */
        get isEdited(): boolean {
            const isEditedPage = Business.page.isEditedPage;
            const isEditedModal = Business.page.isEditedModal;
            return isEditedPage || isEditedModal;
        },

        /**
         * 編集中チェック（Modal）
         * @param event
         */
        get isEditedPage(): boolean {

            //const spirit = $(PageBase.INSTANCE_RETAINER).data(PageBase.DATA_KEY) || $(document).data(PageBase.DATA_KEY);
            //if (spirit instanceof PageBase) {
            //    if (spirit.isEdited) { return true; }
            //}

            const spirit = Business.page.pageInstance;
            if (spirit) {
                if (spirit.isEdited) { return true; }
            }

            //return true;//stub
            return false;
        },


        /**
         * 編集中チェック（Modal）
         * @param event
         */
        get isEditedModal(): boolean {
            const spirit = Business.page.modalInstance;
            if (spirit) {
                if (spirit.isEdited) { return true; }
            }
            //return true;//stub
            return false;
        },

        /**
         * 強制的に編集状態をキャンセルする
         */
        immediateEditCancel() {
            const modal = Business.page.pageInstance;
            if (modal) { modal.isEdited = false; }
            const page = Business.page.pageInstance;
            if (page) { page.isEdited = false; }
        },

        /**
         * 編集中チェック
         * @param event
         */
        async confirmClose(callback: (result: DialogResultType) => void) {

            //if (window.confirm && Business.page.isEdited) {
            if (Business.page.isEdited) {
                //ConfirmDialog('このページから移動しますか？', '行った変更が保存されない可能性があります。', callback);
                //ConfirmDialog(Business.conifrmTitie, Business.conifrmMessage, callback);
                //自前のダイアログは廃止。Legacyなスタイルに変更（Mobileでどうなるかが心配）
                if (window.confirm(Business.conifrmTitie + "\n" + Business.conifrmMessage)) {
                    callback("ok");
                } else {
                    //callback("cancel");
                    callback("no");
                }
            } else {
                callback("ok");
            }
        },

        /**
         * 編集中チェック(Modalのみ)
         * @param event
         */
        async confirmCloseModal(callback: (result: DialogResultType) => void, modalInstance?: ModalBase) {
            var isEdit = false;
            if (modalInstance) {
                isEdit = modalInstance.isEdited;
            } else {
                isEdit = Business.page.isEditedModal;
            }
            if (isEdit) {
                //Modalの「hiding」イベントでインターセプト仕様としたが、下記自前のダイアログにしてしまうと非同期になり、hiding処理を止められない為
                //Legacyなスタイルにする（beforeUnloadではそもそも自前のダイアログを表示出来ない為、平仄があっていいかも）
                //ConfirmDialog('このページから移動しますか？', '行った変更が保存されない可能性があります。', callback);
                //ConfirmDialog(Business.conifrmTitie, Business.conifrmMessage, callback);
                if (window.confirm(Business.conifrmTitie + "\n" + Business.conifrmMessage)) {
                    callback("ok");
                } else {
                    //callback("cancel");
                    callback("no");
                }
            } else {
                callback("ok");
            }
        },

        /**
         * 編集中チェック
         * @param event
         */
        confirmCloseHandler(event) {

            if (Business.page.isEdited) {
                //そもそもiOS-Safariではうまく動かないらしい
                event.preventDefault();
                //ChromeやFireFoxなどではメッセージは変更不可!IE、EdgeはOK？
                //const message = 'UnLoad?';

                event.returnValue = Business.conifrmMessage;
                return Business.conifrmMessage;
            }
        },

        /**
         * ページの破棄を監視する
         */
        checkPageCloseOn() {
            //一旦アンバインド
            Business.page.checkPageCloseOff();
            //編集中チェック
            $(window).on('beforeunload', Business.page.confirmCloseHandler);

            //TODO mobile Safari対応 https://zapanet.info/blog/item/3361
            //mobile Safariではbeforeunloadは効かなくて、
            //それどころかブラウザによって挙動も少しずつ変わってくることがわかりました。
            //beforeunloadではなくpagehideを使ったり、実装するのはけっこう面倒くさそうです

            //$(window).on('pagehide', Business.page.confirmClose);
        },


        /**
         * ページの破棄を解除する
         * 更新処理で、スクリーンナビゲーション(PostBackなどが発生する場合はこれで解除する)
         */
        checkPageCloseOff() {
            //編集中チェック解除
            $(window).off('beforeunload', Business.page.confirmCloseHandler);
            //TODO mobile Safari対応 https://zapanet.info/blog/item/3361
            //$(window).on('pagehide', Business.page.confirmClose);
        }
    }

}
